import {
  Controller,
  ControllerRenderProps,
  useFormContext,
} from 'react-hook-form';
import {
  IPublicRequestMetersData,
  MeterType,
} from 'app/pages/request-single-page/request-single-page-slice';
import {
  Divider,
  Text,
  VStack,
} from 'app/pages/request-single-page/components-v4';
import { useResponsive } from 'app/hooks';
import { ReadingsFormValues } from '../../../meters-readings-modal';
import { validateMeterReading } from '../../../utils/validate-meter-reading';
import { MeterReadingInput } from './meter-reading-input';

type Props = {
  meterId: string;
  meterType: MeterType;
  index: number;
  label: string | null;
  lastReading: IPublicRequestMetersData['last_readings'][number] | undefined;
  unit: string;
  digitCapacity: number;
  showDivider: boolean;
};

export const MeterReadingRow = ({
  meterId,
  meterType,
  index,
  label,
  lastReading,
  unit,
  digitCapacity,
  showDivider,
}: Props) => {
  const { viewport } = useResponsive();
  const { control, errors, clearErrors } = useFormContext<ReadingsFormValues>();

  const fieldName = `${meterId}_${index}`;
  const lastValue = lastReading?.value ?? null;
  const lastValueNum = parseFloat(lastValue ?? '0');

  const handleChange = (
    onChange: ControllerRenderProps['onChange'],
    value: number | undefined
  ) => {
    onChange(value);
    clearErrors(fieldName);
  };

  return (
    <VStack spacing="s">
      <VStack spacing="xs">
        {label && (
          <Text variant={viewport.mobile ? 'body-14' : 'body-16'}>{label}</Text>
        )}
        <Controller
          control={control}
          name={fieldName}
          defaultValue={undefined}
          rules={{
            required: 'Введите показание счётчика',
            validate: (value) =>
              validateMeterReading(value, lastValueNum, digitCapacity),
          }}
          render={({ onChange, value }) => (
            <MeterReadingInput
              value={value}
              onChange={(value) => handleChange(onChange, value)}
              lastValue={lastValue}
              meterType={meterType}
              unit={unit}
              estimated={lastReading?.estimated_value ?? 0}
              error={errors?.[fieldName]?.message}
            />
          )}
        />
      </VStack>
      {showDivider && <Divider />}
    </VStack>
  );
};
